
export default {
	computed: {
		isInlineFinderResultsPage() {
			return this.$store.getters["navigation/isInlineFinderResultsPage"];
		},
		/**
		 * These results pages show the searched word in an inactive (greyed out)
		 * state, the way they did before the blue branding. Tapping the bar
		 * swaps in the Finder itself, which is the active state.
		 *
		 * @see WFW-6761
		 */
		showsSearchedWord() {
			return Boolean(
				this.isInlineFinderResultsPage && this.$route.params?.tiles
			);
		},
		placeholder() {
			if (this.showsSearchedWord) {
				return this.$route.params.tiles;
			}

			return "EDIT YOUR SEARCH";
		},
		tilesFontsize() {
			const smallerLettersThreshold = 15;
			const queryLength = this.placeholder.length;
			const fontSize = queryLength >= smallerLettersThreshold ? 22 : 25;
			if (queryLength >= smallerLettersThreshold) {
				return `${
					fontSize - (queryLength - smallerLettersThreshold)
				}px`;
			}
			return null;
		},
	},
	methods: {
		onClick() {
			this.$emit("click");
		},
	},
};
